import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ImageCarouselProps {
  images: string[];
}
export function ImageCarousel({
  images
}: ImageCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToPrevious = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  };
  const goToNext = () => {
    setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  };
  return <div className="relative mb-6 -mt-4 group" data-id="element-318">
      {/* Main Image */}
      <div className="overflow-hidden rounded-lg" data-id="element-319">
        <img src={images[currentIndex]} alt={`Product ${currentIndex + 1}`} className="w-full h-auto transition-opacity duration-300" data-id="element-320" />
      </div>

      {/* Navigation Buttons */}
      {images.length > 1 && <>
          <button onClick={goToPrevious} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-all opacity-0 group-hover:opacity-100" aria-label="Previous image" data-id="element-321">
            <ChevronLeft className="w-5 h-5 text-gray-800" data-id="element-322" />
          </button>
          <button onClick={goToNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-all opacity-0 group-hover:opacity-100" aria-label="Next image" data-id="element-323">
            <ChevronRight className="w-5 h-5 text-gray-800" data-id="element-324" />
          </button>
        </>}

      {/* Dots Indicator */}
      {images.length > 1 && <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-325">
          {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2 h-2 rounded-full transition-all ${index === currentIndex ? 'bg-orange-500 w-6' : 'bg-white/70 hover:bg-white'}`} aria-label={`Go to image ${index + 1}`} data-id="element-326" />)}
        </div>}
    </div>;
}